import React from "react";
import {Button, Typography} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";
import {formatCurrency, formatNumber, formatPercent} from "../utils/formatters";

export const OptimizeDetailTable = ({theme, data, loading}) => {
    if (!data || data.length === 0) return <div/>;

    const renderActionCell = (params) => {
        if (!params.row.action) return <div/>;
        const buttonColor = params.row.action === 'Accept' ? theme.palette.button.green : theme.palette.button.gray;
        return (
            <Button sx={{backgroundColor: buttonColor, paddingTop: 0, paddingBottom: 0}}>{params.row.action}</Button>
        );
    };

    const common = {sortable: false, disableColumnMenu: true, headerClassName: 'table-header', type: 'number', headerAlign: 'center'};
    const calcColumns = [
        {...common, width: 120, field: 'product_sku', headerName: 'SKU'},
        {...common, width: 198, field: 'product_name', headerName: 'Product Name'},
        {...common, width: 130, field: 'customer_count', headerName: 'Customer Count', valueFormatter: v => formatNumber(v)},
        {...common, width: 100, field: 'net_price', headerName: 'Net Price', valueFormatter: v => formatCurrency(v)},
        {...common, width: 120, field: 'unit_vcogs', headerName: 'Unit VCOGS', valueFormatter: v => formatCurrency(v)},
        {...common, width: 120, field: 'unit_variable_margin', headerName: 'Unit Var Marg', valueFormatter: v => formatCurrency(v)},
        {...common, width: 120, field: 'variable_margin_percent', headerName: 'Var Marg %', valueFormatter: v => formatPercent(v, 2)},
        {...common, width: 120, field: 'variable_margin', headerName: 'Variable Margin', valueFormatter: v => formatCurrency(v)},
        {...common, width: 130, field: 'rec_price_adjustment', headerName: 'Rec Price Adj', valueFormatter: v => formatPercent(v, 1)},
        {...common, width: 100, field: 'new_price', headerName: 'New Price', valueFormatter: v => formatCurrency(v)},
        {...common, width: 130, field: 'margin_impact', headerName: 'Margin $ Impact', valueFormatter: v => formatCurrency(v)},
        {...common, width: 110, field: 'action', headerName: 'Action', align: 'center', renderCell: renderActionCell}
    ];
    const colDefs = [...calcColumns];

    const determineRowClass = (params) => {
        return params.row.id === 'totals' ? 'table-row-totals' : params.indexRelativeToCurrentPage % 2 === 1 ? 'table-row-odd' : 'table-row-even';
    };

    const determineCellClass = (params) => {
        let classes = '';
        classes += params.field === 'rec_price_adjustment' ? 'table-cell-highlight ' : '';
        classes += params.field === 'margin_impact' ? 'table-cell-good ' : '';
        return classes;
    };

    return (
        <div style={{marginTop: 10, marginLeft: 50, width: 1500}}>
            <Typography variant="h6" color="inherit" style={{marginBottom: 10}}>Detail Table</Typography>
            <DataGrid columns={colDefs} rows={data} loading={loading}
                      columnHeaderHeight={30} rowHeight={30} autoHeight
                      getRowClassName={params => determineRowClass(params)}
                      getCellClassName={(params) => (determineCellClass(params))}
                      hideFooter disableRowSelectionOnClick disableMultipleRowSelection disableColumnResize/>
        </div>
    );
};